module.exports = __webpack_public_path__ + "static/media/back-arrow.90bb815d.svg";